
  //index slide
  const index_splide = document.querySelector('.index_banner_sec .splide');
  if (index_splide) {
    new Splide(index_splide, {
      type: 'loop',
      rewind: false,
      speed: 1000,
      perPage: 1,
      gap: '10px',
      arrows: true,
      pagination: true,
      autoplay: true,
      interval: 4000, // 4 seconds
      pauseOnHover: false,
      pauseOnFocus: false,
    }).mount();
  }


    // Splide slider Announcement bar
    new Splide(".custom_announcementMain", {
        type: "loop",
        arrows: false,
        pagination: false,
        perPage: 5,
        focus: "center",
        gap: "3%",

        // Auto Scroll configuration
        autoScroll: {
        speed: 1,       // lower = slower, higher = faster
        pauseOnHover: true,
        pauseOnFocus: false,
        },
        breakpoints: {
            1500: { perPage: 4, gap: '1rem' },
            1024: { perPage: 3,  gap: '1rem' },
            700: { perPage: 2, },
        },
    }).mount(window.splide.Extensions);
    // Splide slider Announcement bar


// -----------------------Home page multi tab collection js-------------------

  // Tabs
  document.querySelectorAll('.trending__collections__wrapper').forEach((wrapper) => {
    const tabButtons = wrapper.querySelectorAll('.tab-button');
    const tabContents = wrapper.querySelectorAll('.tab-content-inner');

    tabButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        tabButtons.forEach((b) => b.classList.remove('active'));
        tabContents.forEach((c) => c.classList.remove('active'));
        button.classList.add('active');
        tabContents[index].classList.add('active');
      });
    });
  });

  // Slider
  if (typeof Splide !== 'undefined') {
    document.querySelectorAll('.trending__collections__wrapper .splide').forEach((slider) => {
      new Splide(slider, {
        perPage: 3,
        perMove: 1,
        gap: '0rem',
        pagination: false,
        type: 'loop',
        arrows: true,
         breakpoints: {
            767: { perPage: 2 },
            497: { perPage: 1 },
        },
      }).mount();

    });
  }

  
  // Facet
  document.addEventListener("DOMContentLoaded", function () {
    const facetWrap = document.getElementById("FacetsWrapperDesktop");
    if (!facetWrap) return;

    const facetItems = facetWrap.querySelectorAll(".facets__disclosure-vertical");

    facetItems.forEach(item => {
      item.setAttribute("open", "");
    });
  });
  // Facet




if(document.querySelector(".inner-bnr-section, .index_banner_sec")){
  document.body.classList.add("has_banner")
}
